import { useQuery } from "@tanstack/react-query";
import { LootBoxApi, Token } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetMyLootBoxInstances(fullToken: Token) {
    return useQuery({
        queryKey: ["my-lootbox-instances", fullToken?.id ?? "unauthenticated"],
        /*
         * `limit` is REQUIRED here. The pagination middleware defaults to 10 when the
         * caller omits it, so an inventory of more than 10 unopened boxes silently
         * returned only the first page — the Stash strip showed a truncated list AND a
         * truncated count, so boxes a user had just bought appeared to be missing.
         */
        queryFn: () => new LootBoxApi(getConfig(fullToken)).getLootboxInstancesMine({ opened: false, limit: 200 }),
        staleTime: 30 * 1000,
        enabled: !!fullToken,
    });
}
